import React from "react";
import { FeatherLock } from "@subframe/core";

interface FieldFootnoteProps {
  hint?: string;
  example?: string;
  lockReason: string | null;
  errorMessage: string | null;
}

/**
 * The lines under a field's control.
 *
 * Priority is deliberate: an error replaces the hint, because a user who just
 * failed validation needs the fix, not the description. The lock reason always
 * shows — it is the answer to "why can't I type here", which the user asks
 * whether or not anything else is wrong.
 */
export const FieldFootnote: React.FC<FieldFootnoteProps> = ({
  hint,
  example,
  lockReason,
  errorMessage,
}) => {
  if (!hint && !example && !lockReason && !errorMessage) {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-1">
      {lockReason && (
        <span className="flex items-start gap-1 text-caption font-caption text-subtext-color">
          <FeatherLock className="mt-0.5 shrink-0 text-caption font-caption" />
          {lockReason}
        </span>
      )}

      {errorMessage ? (
        <span className="text-caption font-caption text-error-700">{errorMessage}</span>
      ) : (
        hint && <span className="text-caption font-caption text-subtext-color">{hint}</span>
      )}

      {example && (
        <span className="text-caption font-caption text-neutral-400">{example}</span>
      )}
    </div>
  );
};
